export const GET = 'GET_COMPANY_BRANDS'